import React from "react"

const Image = ({img_url, altText, isLocal}) => {
    if (img_url) return <img className="picture" alt={altText ? altText : "img"} src={isLocal ? img_url : `${img_url}`}/>
    else return null
}

export default Image
